export function useWorkTaskId() {
    return window.__NEXT_WORKTASKID__
}
